module.exports = __webpack_public_path__ + "img/suit-5.9611da41.jpg";